import { Pipe, PipeTransform } from '@angular/core';

import { FormatService } from '@services/format.service';

@Pipe({
    name: 'formatAmount'
})
export class FormatAmountPipe implements PipeTransform {

    constructor( private formatSrv: FormatService) {}

    transform(inputValue: string | number, mode?: string, doesShowCurrency = true): string {
        let value: number;
        if(inputValue == null || inputValue === "") {
            return "";
        }

        if(typeof inputValue === "string") {
            value = parseFloat(inputValue.toString().replace(/[.]/g, "").replace(/[,]/, "."));
        } else {
            value = <number>inputValue;
        }

        return this.formatSrv.formatAmount(value, mode, null, doesShowCurrency);
    }

}
